<app-idle-logout></app-idle-logout>
<router-outlet></router-outlet>
<app-toast></app-toast>
<app-confirm-popup></app-confirm-popup>
<app-tour></app-tour>
